module.exports = __webpack_public_path__ + "static/media/painting.01c6c288.jpg";